import { AudioSource } from '../../dataStore/reducers/tracks/tracksReducerDefaultState'
import { DeviceStats } from '@bt-react/libs/devices'
import { PresenterBackground, VirtualBackgrounds } from '../VirtualBackgroundPicker/VirtualBackgroundPicker'

export enum SettingsTabs {
  DeviceSettings = 'device',
  VirtualBackgrounds = 'backgrounds'
}

export interface SettingsModalState {
  selectedWebcam?: DeviceStats
  selectedMicrophone?: DeviceStats
  selectedAudioSource: AudioSource
  videoTrack: any
  selectedTab: SettingsTabs
  backgroundType: VirtualBackgrounds
}

export interface SettingsModalProps {
  audioSource: AudioSource
  selectedWebcamDeviceId: string
  selectedMicrophoneDeviceId: string
  onConfirm(settings: {
    selectedWebcam: any
    selectedMicrophone: any
    audioSource: any
    background: VirtualBackgrounds
  }): void
  onCancel(): void
  isDialInConnected: boolean
  background: PresenterBackground
  selectedTab: SettingsTabs
}
